import scales from "../foundations/scales";
const borders = {
    'border.s': scales[0.0625],
    'border.m': scales[0.125]
};
export default borders;

//# sourceMappingURL=borders.js.map